import * as React from 'react';
import {
	Box,
	Typography,
	CurrencyFormatter,
	Divider,
	PageView,
	Button,
	emitSuccessToast,
	emitErrorToast
} from '@seeneco-ui/core';

import {
	Text,
	Title,
	Value,
	Input,
	Table,
} from './styled';
import FetchingPlaceholder from '@core/ui/fetching-placeholder';
import { getPropInSafe } from '@seeneco-ui/core/utils';
import { copyToClipboard } from '@core/utils/text';
import { createReferalLink } from '@core/utils/referal';
import { refLinks } from '@core/api/status/model';


export type StatusEntryProps = {
	statusIsFetching: boolean;
	tenantIsFetching: boolean;
	tariff: Tariff;
	status: PartnerStatus;
	tenantID: number;
};

const StatusEntry: React.FC<StatusEntryProps> = props => {
	const {
		statusIsFetching,
		tenantIsFetching,
		tariff,
		status,
		tenantID,
	} = props;

	const tariffName = getPropInSafe(tariff, x => x.Name, '-')
	const transitions = getPropInSafe(status, x => x.TransitionsCount, '-')
	const registrations = getPropInSafe(status, x => x.RegistrationsCount, '-')
	const sales = getPropInSafe(status, x => x.SalesCount, '-')

	const handleClick = (clipboardText: string) => () => {
		const result = copyToClipboard(clipboardText)

		if (result) {
			emitSuccessToast({ content: 'Ссылка скопирована' })
		} else {
			emitErrorToast({ content: 'Ссылка не скопирована' })
		}
	}

	const renderReferals = () => {
		return refLinks.map(x => (
			<Box key={x.id}>
				<Divider />
				<Box padding='24px 32px'>
					<Box paddingBottom='24px'>
						<Typography.Title textTransform='none'>{x.title}</Typography.Title>
					</Box>
					<Box display='flex' flexDirection='row' flexWrap='wrap'>
						<Input value={createReferalLink(x.link, tenantID)} readOnly id={x.id} />
						<Box marginTop='6px'>
							<Button appearance='outlined' size='small' onClick={handleClick(createReferalLink(x.link, tenantID))}>Скопировать ссылку</Button>
						</Box>
					</Box>
				</Box>
			</Box>
		))
	}

	return (
		<PageView.Layout>
			<PageView.Content appearance='paper' padding='0' fullWidth>
				<Box padding='24px 32px'>
					<Box>
						<Typography.Title textTransform='none' paddingBottom="24px">Статус</Typography.Title>
						<Title>Уровень</Title>
						<Box width={tenantIsFetching ? 115 : '100%'} paddingBottom='19px'>
							<FetchingPlaceholder appearance='text' isFetching={tenantIsFetching}>
								<Text>
									{tariffName}
								</Text>
							</FetchingPlaceholder>
						</Box>
					</Box>
					<Table>
						<thead>
							<tr>
								<Value>
									<Title>Переходов</Title>
								</Value>
								<Value>
									<Title>Регистраций</Title>
								</Value>
								<Value>
									<Title>Продаж</Title>
								</Value>
								{/* <Value>
									<Title>К выплате</Title>
								</Value> */}
							</tr>
						</thead>
						<tbody>
							<tr>
								<Value>
									<FetchingPlaceholder appearance='text' isFetching={statusIsFetching}>
										<Text>
											{transitions}
										</Text>
									</FetchingPlaceholder>
								</Value>
								<Value>
									<FetchingPlaceholder appearance='text' isFetching={statusIsFetching}>
										<Text>
											{registrations}
										</Text>
									</FetchingPlaceholder>
								</Value>
								<Value>
									<FetchingPlaceholder appearance='text' isFetching={statusIsFetching}>
										<Text>
											{sales}
										</Text>
									</FetchingPlaceholder>
								</Value>
								{/* <Value>
										<FetchingPlaceholder appearance='text' isFetching={isFetching}>
										<Text>
											<CurrencyFormatter.Base needFraction={false} fontWeight={700}>
												{payments}
											</CurrencyFormatter.Base>
											</Text>
										</FetchingPlaceholder>
								</Value> */}
							</tr>
						</tbody>
					</Table>
				</Box>

				{renderReferals()}

			</PageView.Content>
		</PageView.Layout>
	);
}

StatusEntry.displayName = 'StatusEntry';
StatusEntry.defaultProps = {};

export default StatusEntry;
